import { c as _c } from "react/compiler-runtime";
import { LiraAdvContainer } from '@sbt-web/adv';
import { CategoryID } from '@sbt-web/network/types';
import { isCategoryForLargeCard } from '@sbt-web/item-card';
import type { SmartADVItem } from '@/shared/models';
import styles from './index.module.scss';
function addSmartADVItem(item: SmartADVItem, listingCategory: CategoryID, isMobile: boolean) {
  const config = isMobile ? item.msite : item.desktop;
  if (config === null) {
    return;
  }
  if (config.source === 'lira') {
    return <div className={styles['smart-adv-lira']} style={config.style} data-cell-size={isCategoryForLargeCard(listingCategory) ? 'big' : 'normal'}>
        <SmartLiraAdvContainer id={config.id} />
      </div>;
  }
}
const SmartLiraAdvContainer = t0 => {
  const $ = _c(3);
  const {
    id
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      height: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== id) {
    t2 = <div className={styles["smart-adv-lira-wrapper"]} style={t1}><LiraAdvContainer idForAd={id} withPlaceholder={true} className={styles["smart-adv-lira"]} /></div>;
    $[1] = id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export { addSmartADVItem, SmartLiraAdvContainer };